export default "__VITE_PUBLIC_ASSET__68fe894f__"